<template>
    <h2 class="my-text-black" style="text-align: center;">Medios de contacto</h2>
    <v-data-iterator :items="contactos">
        <template v-slot:default="{ items }">
            <template
                v-for="(item, i) in items"
                :key="i"
                >
                <v-card
                >
                    <v-card-item>
                        <v-card-title class="my-text-black">
                            {{ item.raw.tipo }} <v-icon>{{ item.raw.icon }}</v-icon>
                        </v-card-title>
                        <v-card-text class="my-text-black">
                            <a :href="item.raw.link" target="_blank" rel="noopener noreferrer">{{ item.raw.valor }}</a>
                        </v-card-text>
                    </v-card-item>
                </v-card>
                <br>
            </template>
        </template>
    </v-data-iterator>
    <AlertComponent
        :title="alertTitle"
        :text="alertText"
        :alertType="alertType"
        :showAlert="showAlert"
        @close="showAlert = false"
    />
</template>

<style src="../assets/general.css"></style>

<script>
import GeneralService from '@/api/GeneralService';
const generalService = new GeneralService();
import AlertComponent from '@/components/AlertComponent.vue';

export default{
    components:{
        AlertComponent,
    },
    data(){
        return{
            contactos: [],
        }
    },
    async mounted(){
        await this.mostrarAviso();
        await this.loadContactos();
    },
    methods:{
        async loadContactos(){
            const response = await generalService.getContactos();
            if(response.status == 200){
                this.contactos = response.data;
                this.contactos = this.contactos.map(c => {
                    const icono = c.tipo.includes('WhatsApp') ? 'mdi mdi-whatsapp' : c.tipo.includes('Correo') ? 'mdi mdi-email-open-outline' : c.tipo.includes('YouTube') ? 'mdi mdi-youtube' : 'mdi mdi-information-outline';
                    return {
                        ...c,
                        icon: icono,
                    };
                });
            }
        },
        async mostrarAviso(){
            const response = await generalService.getAlertasActivas();
            if(response.status === 200){
                const alertas = response.data;
                if(alertas.length > 0){
                    alertas.forEach(alerta => {
                        this.alertTitle = 'Aviso importante';
                        this.alertText = alerta.descripcion;
                        this.alertType = 'info';
                        this.showAlert = true;
                    });
                }
            }
        }
    }
};
</script>